@if (!accessOrganizationPermissions().canAccessUser && !accessOrganizationPermissions().canAccessRole) {
    <app-no-permission />
} @else {
    <section class="flex flex-col h-full gap-7">
        <div class="flex">
            <app-management-main-panel-title
                [icon]="['fas', 'users']"
                [title]="accessOrganizationPermissions().label" />
        </div>
        <div class="flex flex-col gap-1 flex-1 min-h-0">
            @if (accessOrganizationPermissions().canAccessUser) {
                <app-users-list class="flex flex-1 min-h-0" />
            }
            @if (accessOrganizationPermissions().canAccessRole) {
                <app-roles-list class="flex flex-1 min-h-0" />
            }
        </div>
    </section>
}
